import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { defaultTimePreset, defaultTimezone } from '../constants';
import { DateParams } from '../types';

type TimeFiltersContextState = {
  dateParams: DateParams | undefined;
  setDateParams: (dateParams: DateParams) => void;
  timezone: string;
  setTimezone: (timezone: string) => void;
  timePreset: string;
  setTimePreset: (timePreset: string) => void;
};

export const initialTimeFiltersContextState = {
  dateParams: undefined,
  setDateParams: noop,
  timezone: defaultTimezone,
  setTimezone: noop,
  timePreset: defaultTimePreset,
  setTimePreset: noop,
};

export const TimeFiltersContext = createContext<TimeFiltersContextState>(
  initialTimeFiltersContextState,
);

export const useTimeFiltersContext = () => useContext(TimeFiltersContext);
